/**
 * Utility function to merge classnames
 * Simple implementation without external dependencies
 */
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}

/**
 * Remove Vietnamese diacritics for accent-insensitive search.
 * "Tỉnh Cà Mau" → "tinh ca mau"
 */
export function removeVietnameseTones(str: string): string {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase();
}

/**
 * Accent-insensitive filter for Ant Design Select filterOption.
 */
export function filterOptionVietnamese(input: string, option?: { label?: string }): boolean {
  return removeVietnameseTones(option?.label ?? '').includes(removeVietnameseTones(input));
}
